module.exports = __webpack_public_path__ + "media/images/apple-82e0e5ed405dc64c50f43b234b9bb650.png";